export * from "./STSClient";
export * from "./STS";
export * from "./commands";
export * from "./schemas/schemas_0";
export * from "./models/errors";
export * from "./models/models_0";
export * from "./defaultRoleAssumers";
export { STSServiceException } from "./models/STSServiceException";
